module.exports = __webpack_public_path__ + "media/images/download/e-book06-897c177e6a408ab2b3a7bf6305d3ebbb.png";